<template>
  <section style="margin: auto;" >
    <footer class="docs-footer" style="background: #003d80;">
      <div class="container">
        <div class="foot-top">
          <img alt="IT 企导网" src="https://images.qidao123.com/static/newLogo202507.jpg" />
          <div class="foot-top-item">
            <img src="http://images.qidao123.com/static/footImg/foot1.png" alt="微信订阅号" class="wihte-pd">
            <span class="mt5">微信订阅号</span>
          </div>
          <div class="foot-top-item">
            <img src="http://images.qidao123.com/static/footImg/foot2.png" alt="微信服务号" class="wihte-pd">
            <span class="mt5">微信服务号</span>
          </div>
          <div class="foot-top-item">
            <img src="http://images.qidao123.com/static/footImg/foot3.png" alt="微信客服" class="wihte-pd">
            <span class="mt5">微信客服</span>
          </div>
          <div class="foot-top-item">
            <img src="http://images.qidao123.com/images/xcxqr.png" alt="小程序" class="wihte-pd" style="padding: 3px;">
            <span class="mt5">小程序</span>
          </div>
          <div class="foot-top-item">
            <span class="h5-img">
              <img src="http://images.qidao123.com/images/h5qr.jpg" alt="H5">
            </span>
            <span class="mt5">H5</span>
          </div>
          <div class="foot-top-item">
            <div class="f12" @click="go('/about')"><strong>关于我们</strong></div>
            <div class="f12" @click="go('/business-cooperation')"><strong>商务合作</strong></div>
          </div>
        </div>
        <div class="foot-bottom mt10">
          <span>本站浏览量：{{ configdata.data.visitNumber }}</span>
          <span class="mt10"> ©Copyright {{ configdata.data.year }}-{{currentYear}} {{ configdata.data.companyname }} 版权所有</span>
          <span class="mt10" @click="openGov()"><a href="javascript:void(0);">{{ configdata.data.recordNo }}</a></span>
        </div>
      </div>
    </footer>

  </section>
</template>
<script>
export default {
  name:'vue-foot',
  components: {  },
  data() {
    return {
      configdata:{data:{visitNumber:''}},
      currentYear:new Date().getFullYear(),
    }
  },
  methods:{
    openGov(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    bb(){
      window.open('http://wpa.qq.com/msgrd?v=3&uin='+ this.configdata.data.qq+'&site=qq&menu=yes', '_blank', 'height=544, width=644,toolbar=no,scrollbars=no,menubar=no,status=no');
    },
    getconfig(){
      let that=this;
      $.ajax({
        url:serverUrl+"/basics/getconfig",
        type:"get",
        async:true,
        success: function(data) {
          if(data.code == 200)
          {
            that.configdata=data;
          }
        }

      });
    },
    go(path){
      this.$router.push(path)
    }
  },
  mounted: function () {
    this.getconfig();

  },
}
</script>

<style lang="scss">
.foot-top{
  display: flex;
  font-size: 12px;
}
.foot-top>img{
  /* width: 265px; */
  height: 64px;
}
.foot-top-item{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 50px;
}
.foot-top-item>div:nth-child(1){
  padding-bottom: 70px;
}
.foot-top-item>div:hover{
  color: #eb5412;
  cursor: pointer;
}
.foot-top-item>img{
  width: 100px;
  height: 100px;
}
.foot-bottom{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
}
.foot-bottom a{
  color: #fff !important;
}
.wihte-pd{
  padding: 4px;
  background: #ffffff;
}
.h5-img{
  width: 100px;
  height: 100px;
  overflow: hidden;
  &>img{
    width: 100%;
    height: 100%;
    transform: scale(1.1);
    transform-origin: center;
  }
}
</style>